import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoaderComponent } from './components/loader/loader.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { ContentLayoutComponent } from './components/layout/content-layout/content-layout.component';
import { FullLayoutComponent } from './components/layout/full-layout/full-layout.component';
import { FeatherIconsComponent } from './components/feather-icons/feather-icons.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { RightSidebarComponent } from './components/right-sidebar/right-sidebar.component';
import { BookmarkComponent } from './components/bookmark/bookmark.component';
import { TranslateModule } from '@ngx-translate/core';
import { CustomizerComponent } from './components/customizer/customizer.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DragulaModule } from 'ng2-dragula';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GalleryModule } from '@ks89/angular-modal-gallery';
import 'hammerjs';
import 'mousetrap';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';


// services
import { NavService } from "./services/nav.service";
import { CustomizerService } from "./services/customizer.service";
// Directives
import { ToggleFullscreenDirective } from './directives/fullscreen.directive';
import { SelectOnFocusDirective } from './directives/select-on-focus.directive';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AcQuocGiaControlComponent } from './controls/ac-quoc-gia-control/ac-quoc-gia-control.component';
import { AcThanhPhoQuanHuyenControlComponent } from './controls/ac-thanh-pho-quan-huyen-control/ac-thanh-pho-quan-huyen-control.component';
import { PhuongXaControlComponent } from './controls/phuong-xa-control/phuong-xa-control.component';
import { QuanHuyenControlComponent } from './controls/quan-huyen-control/quan-huyen-control.component';
import { TinhThanhControlComponent } from './controls/tinh-thanh-control/tinh-thanh-control.component';
import { CKEditorModule } from 'ngx-ckeditor';
import { EditorComponent } from './controls/editor/editor.component';
import { SafeHtmlPipe } from './pipes/safe-html';
import { VndCurrencyPipe } from './pipes/vnd-currency.pipe';
import { MatCheckboxModule } from '@angular/material/checkbox';
// import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { NgxCurrencyModule } from 'ngx-currency';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PdfViewerModule } from 'ng2-pdf-viewer'; // <- import PdfViewerModule
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { CategoryControlComponent } from './controls/category-control/category-control.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BodyUsedControlComponent } from './controls/body-used-control/body-used-control.component';
import { PositionControlComponent } from './controls/position-control/position-control.component';
import { ProductUnitControlComponent } from './controls/product-unit-control/product-unit-control.component';
import { ManufacturerControlComponent } from './controls/manufacturer-control/manufacturer-control.component';
import { ProductSearchControlComponent } from './controls/product-search-control/product-search-control.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CustomerSearchControlComponent } from './controls/customer-search-control/customer-search-control.component';
import { SupplierControlComponent } from './controls/supplier-control/supplier-control.component';
import { PopupModule } from '@progress/kendo-angular-popup';
import { AccountControlComponent } from './controls/account-control/account-control.component';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { AccountSearchControlComponent } from './controls/account-search-control/account-search-control.component';
import { SuggestProductControlComponent } from './controls/suggest-product-control/suggest-product-control.component';
import { ReceiptBookCategoryComponent } from './controls/receipt-book-category/receipt-book-category.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { TableComponent } from './components/table/table.component';
import { TableHeaderTooltipComponent } from './components/table/table-header-tooltip/table-header-tooltip.component';
import { FilterComponent } from './components/filter/filter.component';
import { DrawerComponent } from './components/drawer/drawer.component';
import { ExampleDrawerContentComponent } from './components/drawer/example-drawer-content.component';
import { ThemeToggleComponent } from './components/theme-toggle/theme-toggle.component';
import { BaseFormModule } from './modules/base-form/base-form.module';
import { NotificationsDrawerComponent } from './components/notifications/notifications.component';
import { PreserveTimeDirective } from './directives/preserve-time.directive';
import { DisableAutofillDirective } from './directives/disable-autofill.directive';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { PaymentMethodControlComponent } from './controls/payment-method-control/payment-method-control.component';
import { OrderSearchControlComponent } from './controls/order-search-control/order-search-control.component';
import { PurchaseOrderSearchControlComponent } from './controls/purchase-order-search-control/purchase-order-search-control.component';
import { ProductPickupSearchControlComponent } from './controls/product-pickup-search-control/product-pickup-search-control.component';
import { PaymentMethodDialogComponent } from './components/dialogs/payment-method-dialog/payment-method-dialog.component';
import { NotificationDropdownComponent } from './components/notification-dropdown/notification-dropdown.component';
import { AddSupplierDialogComponent } from '../module/quan-ly-supplier/add-supplier-dialog/add-supplier-dialog.component';
import { AddProductUnitDialogComponent } from '../module/quan-ly-san-pham/dialog/add-product-unit-dialog/add-product-unit-dialog.component';
import { AddCategoryDialogComponent } from '../module/quan-ly-san-pham/dialog/add-category-dialog/add-category-dialog.component';
import { AddBodyUsedDialogComponent } from '../module/quan-ly-san-pham/dialog/add-body-used-dialog/add-body-used-dialog.component';
import { AddPositionDialogComponent } from '../module/quan-ly-san-pham/dialog/add-position-dialog/add-position-dialog.component';
import { AddManufacturerDialogComponent } from '../module/quan-ly-san-pham/dialog/add-manufacturer-dialog/add-manufacturer-dialog.component';
import { EditThuocDialogComponent } from '../module/quan-ly-san-pham/dialog/edit-thuoc-dialog/edit-thuoc-dialog.component';
import { DetailThuocDialogComponent } from '../module/quan-ly-san-pham/dialog/detail-thuoc-dialog/detail-thuoc-dialog.component';
import { ProductImageDialogComponent } from '../module/quan-ly-san-pham/product-image-dialog/product-image-dialog.component';
import { DiscountDialogComponent } from '../module/quan-ly-san-pham/dialog/discount-dialog/discount-dialog.component';
import { AddHangHoaDialogComponent } from '../module/quan-ly-san-pham/dialog/add-hang-hoa-dialog/add-hang-hoa-dialog.component';
import { AddMedicineDialogComponent } from '../module/quan-ly-san-pham/dialog/add-medicine-dialog/add-medicine-dialog.component';
import { AddCustomerDialogComponent } from '../sales/add-customer-dialog/add-customer-dialog.component';
import { AddCustomerDialogV2Component } from '../sales/add-customer-dialog-v2/add-customer-dialog-v2.component';
import { EditThuocDrawerComponent } from '../module/quan-ly-san-pham/drawer/edit-thuoc-drawer/edit-thuoc-drawer.component';
import { DetailThuocDrawerComponent } from '../module/quan-ly-san-pham/drawer/detail-thuoc-drawer/detail-thuoc-drawer.component';
import { AddMedicineDrawerComponent } from '../module/quan-ly-san-pham/drawer/add-medicine-drawer/add-medicine-drawer.component';
import { AddHangHoaDrawerComponent } from '../module/quan-ly-san-pham/drawer/add-hang-hoa-drawer/add-hang-hoa-drawer.component';

@NgModule({
  declarations: [
    LoaderComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    BookmarkComponent,
    RightSidebarComponent,
    ContentLayoutComponent,
    FullLayoutComponent,
    FeatherIconsComponent,
    ToggleFullscreenDirective,
    SelectOnFocusDirective,
    BreadcrumbComponent,
    CustomizerComponent,
    PaginatorComponent,
    AcQuocGiaControlComponent,
    AcThanhPhoQuanHuyenControlComponent,
    PhuongXaControlComponent,
    QuanHuyenControlComponent,
    TinhThanhControlComponent,
    EditorComponent,
    SafeHtmlPipe,
    VndCurrencyPipe,
    CategoryControlComponent,
    BodyUsedControlComponent,
    PositionControlComponent,
    ProductUnitControlComponent,
    ManufacturerControlComponent,
    ProductSearchControlComponent,
    CustomerSearchControlComponent,
    SupplierControlComponent,
    AccountControlComponent,
    AccountSearchControlComponent,
    SuggestProductControlComponent,
    ReceiptBookCategoryComponent,
    TableComponent,
    TableHeaderTooltipComponent,
    FilterComponent,
    DrawerComponent,
    ExampleDrawerContentComponent,
    ThemeToggleComponent,
    NotificationsDrawerComponent,
    PreserveTimeDirective,
    DisableAutofillDirective,
    PaymentMethodControlComponent,
    OrderSearchControlComponent,
    PurchaseOrderSearchControlComponent,
    ProductPickupSearchControlComponent,
    PaymentMethodDialogComponent,
    NotificationDropdownComponent,
    AddSupplierDialogComponent,
    AddProductUnitDialogComponent,
    AddCategoryDialogComponent,
    AddBodyUsedDialogComponent,
    AddPositionDialogComponent,
    AddManufacturerDialogComponent,
    EditThuocDialogComponent,
    DetailThuocDialogComponent,
    ProductImageDialogComponent,
    DiscountDialogComponent,
    AddHangHoaDialogComponent,
    AddMedicineDialogComponent,
    AddCustomerDialogComponent,
    AddCustomerDialogV2Component,
    EditThuocDrawerComponent,
    DetailThuocDrawerComponent,
    AddMedicineDrawerComponent,
    AddHangHoaDrawerComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    DragDropModule,
    DragulaModule.forRoot(),
    NgbModule,
    GalleryModule.forRoot(),
    FlexLayoutModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatAutocompleteModule,
    MatSelectModule,
    CKEditorModule,
    MatCheckboxModule,
    // NgxJsonViewerModule,
    NgxCurrencyModule,
    InfiniteScrollModule,
    PdfViewerModule,
    NgxExtendedPdfViewerModule,
    MatIconModule,
    MatTooltipModule,
    NgSelectModule,
    PopupModule,
    DateInputsModule,
    ColorPickerModule,
    BaseFormModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatMomentModule,
    MatTabsModule,
  ],
  exports: [
    LoaderComponent,
    SelectOnFocusDirective,
    FeatherIconsComponent,
    TranslateModule,
    DragDropModule,
    FlexLayoutModule,
    MatDatepickerModule,
    MatMomentDateModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    AcQuocGiaControlComponent,
    AcThanhPhoQuanHuyenControlComponent,
    PhuongXaControlComponent,
    QuanHuyenControlComponent,
    TinhThanhControlComponent,
    MatSelectModule,
    EditorComponent,
    CKEditorModule,
    SafeHtmlPipe,
    VndCurrencyPipe,
    MatCheckboxModule,
    // NgxJsonViewerModule,
    NgxCurrencyModule,
    InfiniteScrollModule,
    PdfViewerModule,
    NgxExtendedPdfViewerModule,
    CategoryControlComponent,
    MatIconModule,
    BodyUsedControlComponent,
    PositionControlComponent,
    MatTooltipModule,
    ManufacturerControlComponent,
    ProductUnitControlComponent,
    ProductSearchControlComponent,
    NgSelectModule,
    CustomerSearchControlComponent,
    SupplierControlComponent,
    PopupModule,
    AccountControlComponent,
    DateInputsModule,
    AccountSearchControlComponent,
    SuggestProductControlComponent,
    ReceiptBookCategoryComponent,
    ColorPickerModule,
    ColorPickerModule,
    TableComponent,
    FilterComponent,
    DrawerComponent,
    ThemeToggleComponent,
    BaseFormModule,
    NotificationsDrawerComponent,
    PreserveTimeDirective,
    DisableAutofillDirective,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatMomentModule,
    MatTabsModule,
    PaymentMethodControlComponent,
    OrderSearchControlComponent,
    PurchaseOrderSearchControlComponent,
    ProductPickupSearchControlComponent,
    PaymentMethodDialogComponent,
    NotificationDropdownComponent,
    AddSupplierDialogComponent,
    AddProductUnitDialogComponent,
    AddCategoryDialogComponent,
    AddBodyUsedDialogComponent,
    AddPositionDialogComponent,
    AddManufacturerDialogComponent,
    EditThuocDialogComponent,
    DetailThuocDialogComponent,
    ProductImageDialogComponent,
    DiscountDialogComponent,
    AddHangHoaDialogComponent,
    AddMedicineDialogComponent,
    AddCustomerDialogComponent,
    AddCustomerDialogV2Component,
    EditThuocDrawerComponent,
    DetailThuocDrawerComponent,
    AddMedicineDrawerComponent,
    AddHangHoaDrawerComponent
  ],
  providers: [
    NavService,
    CustomizerService
  ]
})
export class SharedModule { }
